module.exports = __webpack_public_path__ + "static/media/user-astronaut.e578c727.svg";